"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LowerContentWrapper = exports.TileContentWrapper = exports.TileContainer = void 0;
var merch_components_1 = require("@carvana/merch-components");
exports.TileContainer = (0, merch_components_1.createComponent)('div', {
    className: 'group/main min-h-[365px] max-w-[500px] m:h-[397px] m:rounded-md m:border m:border-solid m:border-grey-2'
});
exports.TileContentWrapper = (0, merch_components_1.createComponent)('div', {
    className: "\n     grid\n     h-full\n     w-full\n     grid-cols-1\n     grid-rows-[180px_1fr]\n     overflow-hidden\n     rounded-md\n     bg-white\n     shadow-[0px_2px_3px_rgba(24,53,88,0.1)]\n     group-hover/main:shadow-[0px_6px_13px_rgba(24,53,88,0.1)]\n  "
});
exports.LowerContentWrapper = (0, merch_components_1.createComponent)('div', {
    className: 'grid grid-cols-1 grid-rows-[20px_44px_1fr_auto] gap-y-12 px-16 py-12 text-blue-6 m:grid-rows-[20px_44px_1fr_auto]'
});
//# sourceMappingURL=MerchTile.styles.js.map